<template>
  <qx-card title="调度信息">
    <qx-detail-box
      v-for="(data, index) in detailData"
      :data="data"
      :key="index"
    >
      <span slot="orderScheduler.appointWayName">
        <span>{{
          orderDetail &&
          orderDetail.orderScheduler &&
          orderDetail.orderScheduler.appointWayName
        }}</span>
        <span
          class="error-info error"
          v-if="
            orderDetail &&
            orderDetail.orderSchedulerVer &&
            orderDetail.orderScheduler.appointWayName !==
              orderDetail.orderSchedulerVer.appointWayName
          "
          >修改为：{{ orderDetail.orderSchedulerVer.appointWayName }}</span
        >
      </span>
      <span slot="orderInfo.isNeedBillName">
        <span>{{
          orderDetail &&
          orderDetail.orderInfo &&
          orderDetail.orderInfo.isNeedBillName
        }}</span>
        <span
          class="error-info error"
          v-if="
            orderDetail &&
            orderDetail.orderInfoVer &&
            orderDetail.orderInfo.isNeedBillName !==
              orderDetail.orderInfoVer.isNeedBillName
          "
          >修改为：{{ orderDetail.orderInfoVer.isNeedBillName }}</span
        >
      </span>
      <span slot="orderScheduler.plateNumber" slot-scope="prop">
        <span
          class="primary cur"
          @click="toVehicleDetail(prop.data.orderScheduler)"
          >{{ prop.data.orderScheduler.plateNumber }}</span
        >
      </span>
      <span slot="myCustom.driverInfo" slot-scope="prop">
        <span
          class="primary cur"
          @click="toDriverDetail(prop.data.orderScheduler.carDriverId)"
        >
          {{ prop.data.orderScheduler.carDriverMan }}/{{
            prop.data.orderScheduler.carDriverPhone
          }}
        </span>
        <BankAccount
          v-if="
            (prop.data.orderScheduler.isCollection === null ||
              prop.data.orderScheduler.isCollection !== 1) &&
            (prop.data.orderInfo.toTenantId === null ||
              prop.data.orderInfo.toTenantId <= 0) &&
            prop.data.orderScheduler.carDriverId !== null &&
            prop.data.orderScheduler.carDriverId > 0
          "
          :receiverUserInfo="{
            userId: prop.data.orderScheduler.carDriverId,
            linkman: prop.data.orderScheduler.carDriverMan,
            mobilePhone: prop.data.orderScheduler.carDriverPhone,
            userType: 3,
          }"
        />
      </span>
      <span slot="orderScheduler.copilotMan" slot-scope="prop">
        <span class="primary cur">
          {{ prop.data.orderScheduler.copilotMan }}/{{
            prop.data.orderScheduler.copilotPhone
          }}
        </span>
      </span>
      <span slot="orderScheduler.onDutyDriverName" slot-scope="prop">
        <span
          class="primary cur"
          @click="toDriverDetail(prop.data.orderScheduler.onDutyDriverId)"
        >
          {{ prop.data.orderScheduler.onDutyDriverName }}/{{
            prop.data.orderScheduler.onDutyDriverPhone
          }}
        </span>
      </span>
      <span slot="orderScheduler.trailerPlate" slot-scope="prop">
        <span class="-primary -cur">
          {{ prop.data.orderScheduler.trailerPlate }}
        </span>
      </span>
      <section
        class="order-detail-content-box"
        slot="myCustom.vehicleInfo"
        slot-scope="prop"
      >
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">车牌：</span>
          <span
            class="primary cur"
            @click="toVehicleDetail(prop.data.orderScheduler)"
            >{{ prop.data.orderScheduler.plateNumber }}</span
          >
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderSchedulerVer &&
              orderDetail.orderScheduler.plateNumber !==
                orderDetail.orderSchedulerVer.plateNumber
            "
            >修改为：{{ orderDetail.orderSchedulerVer.plateNumber }}</span
          >
        </p>
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">车类：</span>
          <span>{{ prop.data.orderScheduler.vehicleClassName }}</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderSchedulerVer &&
              orderDetail.orderScheduler.vehicleClassName !==
                orderDetail.orderSchedulerVer.vehicleClassName
            "
            >修改为：{{ orderDetail.orderSchedulerVer.vehicleClassName }}</span
          >
        </p>
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">车型：</span>
          <span v-if="orderDetail.orderScheduler.licenceType !== 2">
            {{
              orderDetail.orderScheduler.carStatusName
                ? orderDetail.orderScheduler.carStatusName
                : '-'
            }}
            /
            {{
              orderDetail.orderScheduler.carLengh
                ? orderDetail.orderScheduler.carLengh
                : '-'
            }}米
          </span>
          <span v-if="orderDetail.orderScheduler.licenceType === 2">拖头</span>
          <template
            v-if="
              orderDetail &&
              orderDetail.orderSchedulerVer &&
              (orderDetail.orderScheduler.carStatusName !==
                orderDetail.orderSchedulerVer.carStatusName ||
                orderDetail.orderScheduler.carLengh !==
                  orderDetail.orderSchedulerVer.carLengh)
            "
          >
            <template v-if="orderDetail.orderSchedulerVer.licenceType !== 2">
              <span class="error-info error">
                修改为：
                {{
                  orderDetail.orderSchedulerVer.carStatusName
                    ? orderDetail.orderSchedulerVer.carStatusName
                    : '-'
                }}
                /
                {{
                  orderDetail.orderSchedulerVer.carLengh
                    ? orderDetail.orderSchedulerVer.carLengh
                    : '-'
                }}米
              </span>
            </template>
            <template v-if="orderDetail.orderSchedulerVer.licenceType === 2">
              <span class="error-info error">修改为：拖头</span>
            </template>
          </template>
        </p>

        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">能源类型：</span>
          <span>{{ prop.data.energyTypeName }}</span>
          <span
              class="error-info error"
              v-if="
              orderDetail && orderDetail.energyTypeNameVer &&
              orderDetail.energyTypeName !==
                orderDetail.energyTypeNameVer
            "
          >修改为：{{ orderDetail.energyTypeNameVer }}</span
          >
        </p>

        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">车辆备注：</span>
          <span>{{ prop.data.vehicleRemark }}</span>
          <span
              class="error-info error"
              v-if="
              orderDetail && orderDetail.vehicleRemarkVer &&
              orderDetail.vehicleRemark !==
                orderDetail.vehicleRemarkVer
            "
          >修改为：{{ orderDetail.vehicleRemarkVer }}</span
          >
        </p>

        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">主驾：</span>
          <span
            class="primary cur"
            @click="toDriverDetail(prop.data.orderScheduler.carDriverId)"
          >
            {{ prop.data.orderScheduler.carDriverMan }} /
            {{ prop.data.orderScheduler.carDriverPhone }}
          </span>
          <BankAccount
            v-if="
              (prop.data.orderScheduler.isCollection === null ||
                prop.data.orderScheduler.isCollection !== 1) &&
              (prop.data.orderInfo.toTenantId === null ||
                prop.data.orderInfo.toTenantId <= 0) &&
              prop.data.orderScheduler.carDriverId !== null &&
              prop.data.orderScheduler.carDriverId > 0
            "
            :receiverUserInfo="{
              userId: prop.data.orderScheduler.carDriverId,
              linkman: prop.data.orderScheduler.carDriverMan,
              mobilePhone: prop.data.orderScheduler.carDriverPhone,
              userType: 3,
            }"
          />
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderSchedulerVer &&
              orderDetail.orderScheduler.carDriverId !==
                orderDetail.orderSchedulerVer.carDriverId
            "
            >修改为：{{ orderDetail.orderSchedulerVer.carDriverMan }} /
            {{ orderDetail.orderSchedulerVer.carDriverPhone }}</span
          >
        </p>
        <p
          class="order-detail-content-item"
          v-if="prop.data.orderScheduler.copilotMan"
        >
          <span class="order-detail-content-item-label">副驾：</span>
          <span>{{ prop.data.orderScheduler.copilotMan }}</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderSchedulerVer &&
              orderDetail.orderSchedulerVer.copilotMan &&
              orderDetail.orderScheduler.copilotUserId !==
                orderDetail.orderSchedulerVer.copilotUserId
            "
            >修改为：{{ orderDetail.orderSchedulerVer.copilotMan }} /
            {{ orderDetail.orderSchedulerVer.copilotPhone }}</span
          >
        </p>
        <p
          class="order-detail-content-item"
          v-if="prop.data.orderScheduler.onDutyDriverName"
        >
          <span class="order-detail-content-item-label">当值司机：</span>
          <span
            class="primary cur"
            @click="toDriverDetail(prop.data.orderScheduler.onDutyDriverId)"
          >
            {{ prop.data.orderScheduler.onDutyDriverName }} /
            {{ prop.data.orderScheduler.onDutyDriverPhone }}
          </span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderSchedulerVer &&
              orderDetail.orderSchedulerVer.onDutyDriverName &&
              orderDetail.orderScheduler.onDutyDriverId !==
                orderDetail.orderSchedulerVer.onDutyDriverId
            "
            >修改为：{{ orderDetail.orderSchedulerVer.onDutyDriverName }} /
            {{ orderDetail.orderSchedulerVer.onDutyDriverPhone }}</span
          >
        </p>
        <p
          class="order-detail-content-item"
          v-if="prop.data.orderScheduler.trailerPlate"
        >
          <span class="order-detail-content-item-label">挂车车牌：</span>
          <span
            class="primary cur"
            @click="
              toTrailerDetail(
                prop.data.orderScheduler.trailerPlate,
                prop.data.orderScheduler.trailerId
              )
            "
            >{{ prop.data.orderScheduler.trailerPlate }}</span
          >
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderSchedulerVer &&
              orderDetail.orderSchedulerVer.trailerPlate &&
              orderDetail.orderScheduler.trailerPlate !==
                orderDetail.orderSchedulerVer.trailerPlate
            "
            >修改为：{{ orderDetail.orderSchedulerVer.trailerPlate }}</span
          >
        </p>
        <p
          class="order-detail-content-item"
          v-if="prop.data.orderInfoExt.drivingType"
        >
          <span class="order-detail-content-item-label">单/双驾：</span>
          <span>{{ prop.data.orderInfoExt.drivingType }}</span
          >
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderInfoExtVer &&
              orderDetail.orderInfoExtVer.drivingType &&
              orderDetail.orderInfoExt.drivingType !==
                orderDetail.orderInfoExtVer.drivingType
            "
            >修改为：{{ orderDetail.orderInfoExtVer.drivingType }}</span
          >
        </p>
      </section>

      <section
        class="order-detail-content-box"
        slot-scope="prop"
        slot="myCustom.oilInfo"
      >
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">空载油耗：</span>
          <span>{{ prop.data.orderInfoExt.capacityOil / 100 }} 升/百公里</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderInfoExtVer &&
              orderDetail.orderInfoExt.capacityOil !==
                orderDetail.orderInfoExtVer.capacityOil
            "
            >修改为：{{
              orderDetail.orderInfoExtVer.capacityOil
            }}
            升/百公里</span
          >
        </p>
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">载重油耗：</span>
          <span>{{ prop.data.orderInfoExt.runOil / 100 }} 升/百公里</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderInfoExtVer &&
              orderDetail.orderInfoExt.runOil !==
                orderDetail.orderInfoExtVer.runOil
            "
            >修改为：{{ orderDetail.orderInfoExtVer.runOil }} 升/百公里</span
          >
        </p>
        <p
            class="order-detail-content-item"
            v-if="isPaymentWay(prop.data.orderInfoExt, 2)"
          >
          <span class="order-detail-content-item-label">油账户：</span>
          <span>{{ prop.data.orderFee.preOilVirtualFee / 100 }} 元</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderFeeVer &&
              orderDetail.orderFee.preOilVirtualFee !==
                orderDetail.orderFeeVer.preOilVirtualFee
            "
            >修改为：{{ orderDetail.orderFeeVer.preOilVirtualFee }} 元</span
          >
        </p>

        <template v-if="isPaymentWay(prop.data.orderInfoExt, 2)">
          <p
            class="order-detail-content-item"
            v-for="(item, index) in prop.data.oilCardInfos"
            :key="index"
          >
            <span class="order-detail-content-item-label"
              >油卡{{ index + 1 }}：</span
            >
            <span>
              {{ item.oilCardNum }} / {{ item.cardTypeName }} /
              {{ item.cardBalance / 100 }} 元
            </span>
          </p>
        </template>
        <p
          class="order-detail-content-item"
          v-if="isPaymentWay(prop.data.orderInfoExt, 1)"
        >
          <span class="order-detail-content-item-label">单公里路桥：</span>
          <span
            >{{
              orderDetail &&
              orderDetail.orderFeeExt &&
              orderDetail.orderFeeExt.pontagePer / 100
            }}
            元/公里</span
          >
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderFeeExtVer &&
              orderDetail.orderFeeExt.pontagePer !==
                orderDetail.orderFeeExtVer.pontagePer
            "
            >修改为：{{
              orderDetail.orderFeeExtVer.pontagePer / 100
            }}
            元/公里</span
          >
        </p>
        <p
          class="order-detail-content-item"
          v-if="isPaymentWay(prop.data.orderInfoExt, 1)"
        >
          <span class="order-detail-content-item-label">空载距离：</span>
          <span
            >{{
              orderDetail &&
              orderDetail.orderInfoExt &&
              orderDetail.orderInfoExt.runWay
            }}
            KM</span
          >
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderInfoExtVer &&
              orderDetail.orderInfoExt.runWay !==
                orderDetail.orderInfoExtVer.runWay
            "
            >修改为：{{ orderDetail.orderInfoExtVer.runWay }} KM</span
          >
        </p>
      </section>

      <section slot="myCustom.orderChart">
        <DetailItem
            :detailItemList="freightDetailItemList"
            :orderDetail="orderDetail"
            propName="frightDetail"
        />
      </section>

      <!-- 指派员工 -->
      <section
        class="order-detail-content-box"
        slot-scope="prop"
        slot="myCustom.staffInfo"
      >
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">驻场姓名：</span>
          <span>{{ prop.data.orderGoods.localUserName }}</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderGoodsVer &&
              orderDetail.orderGoods.localUserName !==
                orderDetail.orderGoodsVer.localUserName
            "
            >修改为：{{ orderDetail.orderGoodsVer.localUserName }}</span
          >
        </p>
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">驻场手机：</span>
          <span>{{ prop.data.orderGoods.localPhone }}</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderGoodsVer &&
              orderDetail.orderGoods.localPhone !==
                orderDetail.orderGoodsVer.localPhone
            "
            >修改为：{{ orderDetail.orderGoodsVer.localPhone }}</span
          >
        </p>
        <p
          class="order-detail-content-item"
          v-if="
            prop.data.orderScheduler.sourceId == null ||
            prop.data.orderScheduler.sourceId <= 0
          "
        >
          <span class="order-detail-content-item-label">拦标价：</span>
          <span>{{ prop.data.orderFee.guidePrice / 100 }}元</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderFeeVer &&
              orderDetail.orderFee.guidePrice !==
                orderDetail.orderFeeVer.guidePrice
            "
            >修改为：{{ orderDetail.orderFeeVer.guidePrice }}元</span
          >
        </p>
        <p
          class="order-detail-content-item"
          v-if="
            prop.data.orderScheduler.sourceId == null ||
            prop.data.orderScheduler.sourceId <= 0
          "
        >
          <span class="order-detail-content-item-label">承包价：</span>
          <span>{{ prop.data.orderFee.totalFee / 100 }}元</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderFeeVer &&
              orderDetail.orderFee.totalFee !== orderDetail.orderFeeVer.totalFee
            "
            >修改为：{{ orderDetail.orderFeeVer.totalFee }}元</span
          >
        </p>
      </section>
      <!-- 指派车队 -->
      <section
        class="order-detail-content-box"
        slot-scope="prop"
        slot="myCustom.fleetInfo"
      >
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">车队名称：</span>
          <span>{{ prop.data.orderInfo.toTenantName }}</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderInfoVer &&
              orderDetail.orderFee.toTenantName !==
                orderDetail.orderInfoVer.toTenantName
            "
            >修改为：{{ orderDetail.orderInfoVer.toTenantName }}</span
          >
        </p>
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">收款账户：</span>
          <span>{{ prop.data.orderFee.acctNo }}</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderFeeVer &&
              orderDetail.orderFee.acctNo !== orderDetail.orderFeeVer.acctNo
            "
            >修改为：{{ orderDetail.orderFeeVer.acctNo }}</span
          >
        </p>
        <p class="order-detail-content-item">
          <span class="order-detail-content-item-label">收款人：</span>
          <span>{{ prop.data.orderFee.acctName }}</span>
          <span
            class="error-info error"
            v-if="
              orderDetail &&
              orderDetail.orderFeeVer &&
              orderDetail.orderFee.acctName !== orderDetail.orderFeeVer.acctName
            "
            >修改为：{{ orderDetail.orderFeeVer.acctName }}</span
          >
        </p>
      </section>
      <section slot="orderInfoExt.paymentWayName" slot-scope="prop">
        <span>{{ prop.data.orderInfoExt.paymentWayName }}</span>
        <span
          class="error-info error"
          v-if="
            orderDetail &&
            orderDetail.orderInfoExtVer &&
            orderDetail.orderInfoExt.paymentWayName !==
              orderDetail.orderInfoExtVer.paymentWayName
          "
          >修改为：{{ orderDetail.orderInfoExtVer.paymentWayName }}</span
        >
      </section>
      <section slot="dispatchBalanceTypeName" slot-scope="prop">
        <span>{{ getDispatchBalanceTypeName(prop.data) }}</span>
        <span
          class="error-info error"
          v-if="
            hasDispatchBalanceTypeVer(prop.data) &&
            getDispatchBalanceTypeName(prop.data) !==
              getDispatchBalanceTypeNameVer(prop.data)
          "
          >修改为：{{ getDispatchBalanceTypeNameVer(prop.data) }}</span
        >
      </section>
      <section slot="myCustom.orderFeeInfo" slot-scope="prop">
        <ContractChart ref="contractChart" :orderData="prop.data" />
      </section>
      <section slot="myCustom.contractChart" slot-scope="prop">
        <ContractChart ref="contractChart" :orderData="prop.data" />
      </section>
      <section slot="myCustom.intelligenceChart" slot-scope="prop">
        <IntelligenceChart ref="intelligenceChart" :orderData="prop.data" />
      </section>
    </qx-detail-box>
  </qx-card>
</template>

<script>
import DetailItem from './components/detailItem';
import ContractChart from './components/contractChart';
import IntelligenceChart from './components/intelligenceChart';
import BankAccount from 'components/bankAccount/bankAccount';
import {getOperInteCfgResultInfo} from 'api/operate';
export default {
  components: {
    DetailItem,
    ContractChart,
    IntelligenceChart,
    BankAccount,
  },
  data () {
    return {
      orderDetail: {},
      // 运费信息详情
      freightDetailItemList: [],
      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              { prop: 'orderScheduler.appointWayName', label: '调度方式', slot: true },
              { prop: 'orderInfo.isNeedBillName', label: '票据要求', slot: true },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  methods: {
    toVehicleDetail (item) {
      this.jump({
        label: `查看车辆${item.plateNumber ? ('-' + item.plateNumber) : ''}`,
        url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass}&type=detail`,
        full: true,
      });
    },
    toDriverDetail (carDriverId) {
      this.jump({
        label: '司机详情',
        url: `/manage/archives/driver/archives/detail?id=${carDriverId}&type=${''}`,
        full: true,
      });
    },
    toTrailerDetail (plateNumber, vehicleCode) {
      this.jump({
        label: `查看挂车-${plateNumber}`,
        url: `/manage/car/trailer/archives/detail?id=${vehicleCode}&type=${''}`,
        full: true,
      });
    },
    // 详情数据（用来展示）
    setBaseData (detailRes) {
      const orderInfo = detailRes.orderInfo;
      const orderScheduler = detailRes.orderScheduler;

      this.orderDetail.base = {
        ...this.orderDetail.base,
        appointWayName: orderScheduler.appointWayName,
        isNeedBillName: orderInfo.isNeedBillName,
      };
      // 将对应模块的 详情数据 赋给 data 即可展示在页面上展示
      this.detailData.base.tableData.data = this.orderDetail.base;

      const orderInfoExt = detailRes.orderInfoExt;
      this.orderDetail.base = {
        ...this.orderDetail.base,
        paymentWayName: detailRes.orderInfoExt.paymentWayName,
        frightDetail: this.getFrightDetailData(orderInfoExt, detailRes.moneyValuePayDouble),
      };
    },
    // 审核数据（用来和 详情数据 做对比，如果和 详情数据不一样，则提示）
    setBaseVerData (detailRes) {
      const orderInfo = detailRes.orderInfoVer;
      const orderScheduler = detailRes.orderSchedulerVer;

      this.orderDetail.baseVer = {
        ...this.orderDetail.baseVer,
        appointWayName: orderScheduler.appointWayName,
        isNeedBillName: orderInfo.isNeedBillName,
      };
      // 将对应模块的 审核数据 赋给 approveData 即可自动做对比
      this.detailData.base.tableData.approveData = this.orderDetail.baseVer;

      const orderInfoExt = detailRes.orderInfoExtVer;
      this.orderDetail.baseVer = {
        ...this.orderDetail.baseVer,
        frightDetail: this.getFrightDetailData(orderInfoExt, detailRes.moneyValuePayDouble),
      };
      this.orderDetail.energyTypeNameVer = detailRes.energyTypeNameVer; // 能源类型
    },
    getFrightDetailData (orderInfoExt, moneyValuePayDouble) {
      return {
        fullFreight: this.formatMoney(this.pickField(orderInfoExt, ['fullFreightDouble', 'FULLFREIGHTDOUBLE'])),
        projectSettlementPrice: this.formatMoney(this.pickField(orderInfoExt, ['projectSettlementPriceDouble', 'PROJECTSETTLEMENTPRICEDOUBLE'])),
        driverBasealary: this.formatMoney(this.pickField(orderInfoExt, [
          'driverBasealaryDouble', 'driverBaseSalaryDouble', 'DRIVERBASEALARYDOUBLE',
          'DRIVERBASESALARYDOUBLE',
        ])) + '（本订单趟次基本服务费）',
        coDriverBasealary: this.formatMoney(this.pickField(orderInfoExt, [
          'coDriverBasealaryDouble', 'coDriverBaseSalaryDouble', 'CODRIVERBASEALARYDOUBLE',
          'CODRIVERBASESALARYDOUBLE',
        ])),
        carPrepayMoney: this.formatMoney(this.pickField(orderInfoExt, ['carPrepayMoneyDouble', 'CARPREPAYMONEYDOUBLE'])),
        moneyValuePayDouble: this.formatMoney(moneyValuePayDouble),
        payee: Number(orderInfoExt.payee) === 0 ? '主驾' : '副驾',
        showWagesFlg: this.formatYesNo(orderInfoExt.showWagesFlg),
        taxPoint: this.formatPercent(this.pickField(orderInfoExt, ['taxPointDouble', 'TAXPOINTDOUBLE'])),
        otherFee: this.formatMoney(this.pickField(orderInfoExt, ['otherFeeDouble', 'OTHERFEEDOUBLE'])),
        freightOfOrder: this.formatMoney(this.pickField(orderInfoExt, ['freightOfOrderStr', 'FREIGHTOFORDERSTR', 'freightOfOrderDouble'])),
        actualProportion: this.formatPercent(this.pickField(orderInfoExt, ['actualProportionStr', 'ACTUALPROPORTIONSTR', 'actualProportionDouble'])),
        reportingRole: Number(orderInfoExt.reportingRole) === 1 ? '副驾' : '主驾',
      };

    },
    pickField (data, fields) {
      const source = data || {};
      for (let field of fields) {
        if (source[field] !== undefined && source[field] !== null && source[field] !== '') {
          return source[field];
        }
      }
      return null;
    },
    formatMoney (value) {
      return (value !== undefined && value !== null && value !== '' ? value : '0') + '元';
    },
    formatPercent (value) {
      return (value !== undefined && value !== null && value !== '' ? value : '0') + '%';
    },
    formatYesNo (value) {
      if (value === undefined || value === null || value === '') {
        return '--';
      }
      return Number(value) === 1 ? '是' : '否';
    },
    isAppointWay (orderScheduler, value) {
      return Number(orderScheduler && orderScheduler.appointWay) === Number(value);
    },
    isPaymentWay (orderInfoExt, value) {
      return Number(orderInfoExt && orderInfoExt.paymentWay) === Number(value);
    },
    getDispatchBalanceTypeName (data) {
      const detail = data || {};
      return detail.dispatchBalanceTypeName ||
        (detail.costPaymentDaysInfo && detail.costPaymentDaysInfo.balanceTypeName) || '--';
    },
    getDispatchBalanceTypeNameVer (data) {
      const detail = data || {};
      return detail.dispatchBalanceTypeNameVer ||
        (detail.costPaymentDaysInfoVer && detail.costPaymentDaysInfoVer.balanceTypeName) || '--';
    },
    hasDispatchBalanceTypeVer (data) {
      const detail = data || {};
      return (detail.dispatchBalanceTypeVer !== undefined && detail.dispatchBalanceTypeVer !== null) ||
        !!(detail.costPaymentDaysInfoVer && detail.costPaymentDaysInfoVer.balanceType !== undefined &&
          detail.costPaymentDaysInfoVer.balanceType !== null);
    },
    async parmsConfig (detailRes) { // 订单录入个性化配置
      const freightDetailItemList = [
        {label: '应付运费', value: 'fullFreight'},
        {label: '主驾基本服务费', value: 'driverBasealary'},
        {label: '副驾基本服务费', value: 'coDriverBasealary'},
        {label: '司机是否可见服务费', value: 'showWagesFlg'},
        {label: '税点及操作费用', value: 'taxPoint'},
        {label: '其他费用', value: 'otherFee'},
        {label: '油/气耗上报角色', value: 'reportingRole'},
        {label: '预支/借支款', value: 'carPrepayMoney'},
        {label: '收款角色', value: 'payee'},
        {label: '实际支出金额', value: 'moneyValuePayDouble'},
      ];
      const normalizeFreightDetailItems = (items) => items.map((item) => ({...item}));
      const tenantId = detailRes.vehicleInfo && detailRes.vehicleInfo.tenantId;
      const isOrderMent = await getOperInteCfgResultInfo({
        busiCode: '10010201',
        filedName: '成本模式',
        tenantId,
      });
      if (isOrderMent.length > 0) {
        const paymentWayConfig = isOrderMent.find((item) => `${item.value}` === `${detailRes.orderInfoExt.paymentWay}`) || {};
        const paymentWayList = await getOperInteCfgResultInfo({
          busiCode: '10010201',
          filedName: paymentWayConfig.fieldName || detailRes.orderInfoExt.paymentWayName,
          tenantId,
        });

        // 父级订单模式已配置时，空子项表示全部隐藏，不能回退为硬编码全字段。
        this.freightDetailItemList = normalizeFreightDetailItems(paymentWayList);
      } else {
        this.freightDetailItemList = normalizeFreightDetailItems(freightDetailItemList);
      }
    },
    async getData (detailRes) {
      // 详情数据
      this.orderDetail = detailRes;

      if (detailRes.orderScheduler.appointWay) {
        const insertIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'orderInfo.isNeedBillName') + 1;
        this.detailData.base.tableData.title.length = insertIndex;
        let pushItem = [];
        if (this.isAppointWay(detailRes.orderScheduler, 3)) {
          pushItem.push({
            label: '车辆信息',
            prop: 'myCustom.vehicleInfo',
            slot: true,
            span: 1,
          });
          pushItem.push({
            label: '成本模式',
            prop: 'orderInfoExt.paymentWayName',
            slot: true,
            span: 1,
          });
          if (this.isPaymentWay(detailRes.orderInfoExt, 1)) {
            // 智能模式
            pushItem.push({
              label: '油耗信息',
              prop: 'myCustom.oilInfo',
              slot: true,
              span: 1,
            });
            pushItem.push({
              label: '运费信息',
              prop: 'myCustom.intelligenceChart',
              slot: true,
              span: 1,
              lableHide: true,
            });
          } else if (this.isPaymentWay(detailRes.orderInfoExt, 2)) {
            // 报账模式，显示 空载油耗 和 载重油耗
            pushItem.push({ label: '油耗信息', prop: 'myCustom.oilInfo', slot: true, span: 1 });
          } else if (this.isPaymentWay(detailRes.orderInfoExt, 3)) {
            // 承包模式
            pushItem.push({ label: '运费信息', prop: 'myCustom.contractChart', slot: true, span: 1 });
          } else if (this.isPaymentWay(detailRes.orderInfoExt, 4)) {
            // 订单模式
            pushItem.push({ label: '运费信息', prop: 'myCustom.orderChart', slot: true, span: 1 });
          }
        } else if (this.isAppointWay(detailRes.orderScheduler, 4)) {
          // 指派员工
          pushItem.push(...[
            {
              label: '员工信息',
              prop: 'myCustom.staffInfo',
              slot: true,
              span: 1,
            },
          ]);
        } else if (this.isAppointWay(detailRes.orderScheduler, 5)) {
          // 指派车队
          pushItem.push(...[
            {
              label: '车队信息',
              prop: 'myCustom.fleetInfo',
              slot: true,
              span: 1,
            },
            {
              label: '运费信息',
              prop: 'myCustom.orderFeeInfo',
              slot: true, span: 1,
            },
          ]);
        }
        const requiredDispatchItems = [
          { label: '结算方式', prop: 'dispatchBalanceTypeName', slot: true },
          { label: '运费信息', prop: 'myCustom.orderChart', slot: true, span: 1 },
        ];
        const baseProps = this.detailData.base.tableData.title.map((item) => item.prop);
        const uniqueItems = [];
        requiredDispatchItems.concat(pushItem).forEach((item) => {
          if (!baseProps.includes(item.prop) && !uniqueItems.some((uniqueItem) => uniqueItem.prop === item.prop)) {
            uniqueItems.push(item);
          }
        });
        this.detailData.base.tableData.title.push(...uniqueItems);
      }
      this.parmsConfig(detailRes);


      // 重写各个模块的 详情数据，方便和 审核数据 做对比
      this.setBaseData(detailRes);
      if (this.$route.query.type === 'approve' && detailRes && detailRes.orderInfo.orderUpdateState === 2) {
        // 重写各个模块的 审核数据
        this.setBaseVerData(detailRes);
      }
      this.detailData.base.tableData.data = detailRes;
    },
  },
};
</script>

<style lang="scss" scoped>
.error-info {
  margin-left: 10px;
}
.driverBasealaryLabel{
  width:112px !important
}
.carPrepayMoneyLabel{
  width:190px !important;
}
</style>
